export default __webpack_public_path__ + "static/media/star_grey.fefb6001.svg";